(() => {
  const moneyFormatter = new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
  });

  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  async function fetchCartTotal() {
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin',
    });

    if (!response.ok) throw new Error('Cart fetch failed');
    const cart = await response.json();
    return cart.total_price || 0;
  }

  const checkSvg = '<span class="cart-free-shipping__inline-check is-active"><svg width="14" height="14" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="7.5" fill="#C8A951"/><polyline points="4.5 8 7 10.5 11.5 5.5" stroke="#fff" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></span>';

  function updateWidget(widget, cartTotalCents) {
    const threshold = Number(widget.dataset.threshold || 5000);
    const progress = clamp(Math.round((cartTotalCents / threshold) * 100), 0, 100);
    const remaining = Math.max(0, threshold - cartTotalCents);

    const fill = widget.querySelector('[data-free-shipping-fill]');
    const truck = widget.querySelector('[data-free-shipping-truck]');
    const text = widget.querySelector('[data-free-shipping-text]');
    const percent = widget.querySelector('[data-free-shipping-percent]');
    const track = widget.querySelector('.cart-free-shipping__track');

    if (fill) fill.style.width = `${progress}%`;
    if (truck) truck.style.left = `calc(${progress}% - 14px)`;
    if (truck) {
      if (cartTotalCents >= threshold) {
        if (!truck.classList.contains("is-success")) truck.classList.add("is-success");
      } else {
        truck.classList.remove("is-success");
      }
    }
    if (percent) percent.textContent = `${progress}%`;
    if (track) track.setAttribute('aria-valuenow', String(progress));

    if (text) {
      if (cartTotalCents >= threshold) {
        text.innerHTML = 'Deine Bestellung wird kostenlos versendet! ' + checkSvg;
        text.classList.add('is-success');
      } else {
        text.innerHTML = `Nur noch ${moneyFormatter.format(remaining / 100)} bis kostenloser Versand.`;
        text.classList.remove('is-success');
      }
    }
  }

  async function refreshFreeShippingWidgets() {
    const widgets = document.querySelectorAll('[data-free-shipping]');
    if (!widgets.length) return;

    let cartTotalCents = null;
    try {
      cartTotalCents = await fetchCartTotal();
    } catch (error) {
      console.warn('[Cart Free Shipping] failed to fetch cart', error);
      widgets.forEach((widget) => {
        cartTotalCents = Number(widget.dataset.cartTotal || 0);
        updateWidget(widget, cartTotalCents);
      });
      return;
    }

    widgets.forEach((widget) => updateWidget(widget, cartTotalCents));
  }

  document.addEventListener('DOMContentLoaded', refreshFreeShippingWidgets);
  document.addEventListener('cart:refresh', refreshFreeShippingWidgets);

  if (window.subscribe && window.PUB_SUB_EVENTS?.cartUpdate) {
    subscribe(window.PUB_SUB_EVENTS.cartUpdate, refreshFreeShippingWidgets);
  }

  const observer = new MutationObserver(() => refreshFreeShippingWidgets());
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
